import { render } from "./InputCheck.vue?vue&type=template&id=ee88dde6"
import script from "./InputCheck.vue?vue&type=script&lang=ts"
export * from "./InputCheck.vue?vue&type=script&lang=ts"
script.render = render

export default script